export default [
    {
        path: '/tendero-vip/estadisticas',
        meta: { nombre: 'Estadisticas' },
        name: 'tendero-vip.estadisticas',
        component: () => import(/* webpackChunkName: "promociones" */ '../../pages/estadisticas').then(m => m.default || m)
    }
]
